<template>

    <div class="page-container">

        <div class="all-container">

            <!--keep for desktop-->
            <mq-layout class="align-desktop" mq="lg"></mq-layout>

            <div class="swing-relative-container">

                <div v-for="(card, index) in cardArray"
                     :class="{
                                'second-card': cardPosition(index) === 2,
                                'third-card': cardPosition(index) === 3
                                 }"
                     class="swing-absolute-container">

                    <cards
                        :ref="'swing' + index"
                        :card="card"
                        :position="cardPosition(index)"
                        :throwDirection="throwDirection"
                        class="item-container"

                        @invalidGrant="invalidGrant"
                        @share="share"
                        @throwOutConfidence="updateThrowOutConfidence"
                        @throwoutleft="swipeLeft"
                        @throwoutright="swipeRight"
                        @throwoutup="swipeTop"

                    ></cards>

                </div>
            </div>

            <div v-show="cardArray.length" class="btn-container">

                <div class="bottom-btn-white" @click="btnAction('left')">

                    <img :class="{ disabled: isDisabled }" class="bottom-btn-img-1" src="/img/icons/auto-delete-raspberry.svg">

                </div>

                <div class="bottom-btn-white bottom-btn-little" @click="btnAction('up')">

                    <img :class="{ disabled: isDisabled }" class="bottom-btn-img-2" src="/img/icons/trash-amina.svg">

                </div>

                <div class="bottom-btn-white" @click="btnAction('right')">

                    <img :class="{ disabled: isDisabled }" class="bottom-btn-img-3" src="/img/icons/keep-green.svg">

                </div>

            </div>

            <tuto-card ref="tuto" @close="tutoClosed"></tuto-card>

        </div>

        <modal-share ref="MS" @close="shareModalClose"></modal-share>

    </div>

</template>

<script>

import VueSwing from 'vue-swing'
import Firebase from '@/modules/firebase'
import Storage from '@/helpers/storage'
import Tag from '@/modules/tag'
import UserFlow from '@/modules/userFlow'

import ModalShare from '@/components/modal/ModalShare'
import Cards from '@/components/newsletters/Cards'
import TabBar from '@/components/TabBar'
import TutoCard from '@/components/tuto/TutoCard'

export default {

    name: 'card-container',

    components: {VueSwing, ModalShare, Cards, TabBar, TutoCard},

    watch: {

        newsletters: function () {

            this.init()
        },

        newslettersErrors: function (newslettersArray, oldlettersArray) {

            this.updateCardsError(newslettersArray, oldlettersArray)

        },

        tuto: function (bool) {

            if (bool) {

                this.isTutoActive = true
                this.$refs.tuto.start()

            }
        },

        cardArray: function () {
            if (this.cardArray.length === 0) {
                this.$emit('end')
            }
        }
    },

    props: {

        newsletters: {
            type: Array,
            default: () => []
        },

        newslettersErrors: {
            type: Array,
            default: () => []
        },

        tuto: {
            Type: Boolean,
            default: false
        },

        extras: {
            type: Array,
            default: () => []
        }
    },

    data() {

        return {
            isTutoActive: false,
            cloneNewsletters: [],
            cardArray: [],
            throwDirection: '',
            throwOutConfidence: '0',
            shared: false,
            firstTime: true,
            cardsAlreadyTreated: [],
            sharingCardsPositionDefault: [20, 60]
        }

    },

    computed: {

        onlyStayInvalidGrant: function () {

            return this.cardArray.filter(item => !item.invalidGrant || item.error).length === 0

        },

        isDisabled: function () {

            if (this.cardArray.length) {

                const cardType = this.cardArray[this.cardArray.length - 1].type

                return cardType !== 'newsletter' && cardType !== 'sharing'

            }
        }

    },

    created() {

        UserFlow.setPage(this, 'cleaning_cards')

        Tag.pageViewGA(this, 'cleaning_cards')

        window.addEventListener('keydown', this.keydown)

    },

    mounted() {

        this.init()
    },

    methods: {

        keydown(event) {

            if (!this.isTutoActive) {

                if (event.keyCode === 37) {

                    this.swing('left')

                } else if (event.keyCode === 38) {

                    this.swing('up')

                } else if (event.keyCode === 39) {

                    this.swing('right')

                }
            }
        },

        tutoClosed() {

            this.isTutoActive = false

        },

        updateThrowOutConfidence(value) {
            this.throwOutConfidence = value
        },

        cardPosition(index) {

            return this.cardArray.length - index

        },

        updateCardsError(newslettersArray, oldlettersArray, init) {

            const length = oldlettersArray.length

            const newErrors = init ? this.newslettersErrors : newslettersArray.slice(length)

            newErrors.forEach(cardError => {

                const isAlreadyMetTwice = this.cardsAlreadyTreated.filter(card => card.email === cardError.email && card.sender === cardError.sender).length > 1

                if (isAlreadyMetTwice) {

                    const nbInvalidGrant = this.cardArray.filter(card => card.invalidGrant).length

                    this.cardArray.splice(nbInvalidGrant, 0, cardError)

                } else {

                    if (this.onlyStayInvalidGrant) {

                        this.cardArray.splice(this.cardArray.length, 0, cardError)

                    } else if (this.throwOutConfidence !== '0') {

                        this.cardArray.splice(this.cardArray.length - 2, 0, cardError)

                    } else {

                        this.cardArray.splice(this.cardArray.length - 1, 0, cardError)

                    }
                }
            })

        },

        addSharingCard() {

            if (!Storage.getItem('usedSharingCard')) {

                Firebase.getValue('sharing_cards_positions', 'Object')
                    .then(firebaseData => {

                        if (firebaseData) {

                            this.addCardWithPosition(firebaseData.positions, 'sharingCard')

                        } else {
                            this.addCardWithPosition(this.sharingCardsPositionDefault, 'sharingCard')

                        }
                    })
                    .catch(() => {

                        this.addCardWithPosition(this.sharingCardsPositionDefault, 'sharingCard')

                    })

            }

        },

        addMarketCard() {

            for (const card of this.extras) {
                this.addCardWithPosition([card.position - 1], 'market', card, true)
            }


        },

        replaceInvalidGrant() {

            this.cardArray = [
                ...this.cardArray.filter(item => item.invalidGrant),
                ...this.cardArray.filter(item => !item.invalidGrant)
            ]
        },

        addCardWithPosition(arrayPosition, type, defaultCard = {}, lastPosition) {

            const length = this.cardArray.filter(item => !item.invalidGrant).length

            let card = {
                show: false,
                type: 'custom',
                name: 'custom',
                count: 'custom',
                email: 'custom',
                error: 'custom',
                invalidGrant: false,
                openRate: 'custom',
                selected: 'custom',
                sender: 'custom'
            }

            switch (type) {
                case 'sharingCard':
                    card.type = 'sharing'
                    break
                case 'market':
                    card = {...card, ...defaultCard, type: 'market'}
                    break
            }


            if (lastPosition) {

                for (const position of arrayPosition) {

                    if (position < this.cardArray.length) {
                        this.cardArray.splice(this.cardArray.length - position, 0, card)
                    } else {
                        this.cardArray.unshift(card)
                    }
                }

            } else {

                for (const position of arrayPosition.sort().reverse().filter(pos => length > pos + 1)) {
                    this.cardArray.splice(this.cardArray.length - position, 0, card)
                }

            }

        },

        init() {

            if (this.firstTime && this.newsletters.length) {

                this.firstTime = false

                this.cloneNewsletters = this.newsletters.slice().reverse()

                // Add clonenewsletters to cardArray
                this.fillCardArray()

                // fix errors card in second position
                this.updateCardsError([], [], true)

                // Add sharing card to cardArray
                this.addSharingCard()

                // Add market card to cardArray
                this.addMarketCard()

                // replace invalidgrant at the end
                this.replaceInvalidGrant()

                this.showBeforeLastCard()
            }

        },

        fillCardArray() {
            this.cardArray = this.cloneNewsletters.map(card => {
                card.type = card.type ? card.type : 'newsletter'
                card.show = false
                return card
            })

        },

        cardsActionUpdate(direction) {

            const card = this.cardArray.pop()

            if (card.type === 'newsletter') {

                this.cardsAlreadyTreated.push(card)

                switch (direction) {
                    case 'up':
                        this.$emit('requestDelete', [card])
                        break
                    case 'left':
                        this.$emit('requestUnsubscribe', [card])
                        break
                    case 'right':
                        this.$emit('requestKeep', [card])
                        break
                }

            } else if (card.type === 'sharing') {

                if (this.shared) {

                    this.cardArray = this.cardArray.filter(item => item.type !== 'sharing')

                }

            }

            this.showBeforeLastCard()

            const lastCard = this.cardArray[this.cardArray.length - 1]

            if (lastCard && lastCard.type && lastCard.type === 'sharing') {

                Tag.infoGa(this, 'sharing_appeared')

            }

        },

        showBeforeLastCard() {
            const length = this.cardArray.length

            if (this.cardArray[length - 1]) {

                this.cardArray[length - 1].show = true
            }

            if (this.cardArray[length - 2]) {

                this.cardArray[length - 2].show = true
            }

            if (this.cardArray[length - 3]) {

                this.cardArray[length - 3].show = true
            }
        },

        swipeTop() {

            this.cardsActionUpdate('up')
            Tag.clickAll(this, 'delete_swipe')

        },

        swipeLeft() {
            this.cardsActionUpdate('left')
            Tag.clickAll(this, 'autodelete_swipe')

        },

        swipeRight() {

            this.cardsActionUpdate('right')
            Tag.clickAll(this, 'keep_swipe')

        },

        share() {

            this.$refs.MS.open()

        },

        cardSwipeLoopAnimation(vueswing, direction) {

            return new Promise(resolve => {

                const reactivity = 50
                const duration = 5
                const dpi = 8

                const cardSwipeAnimation = this.cardSwipeAnimation

                for (let index = 1; index <= reactivity; index++) {

                    setTimeout(function () {
                        cardSwipeAnimation(vueswing, index, dpi, direction)
                    }, index * duration)
                }

                setTimeout(function () {
                    resolve()
                }, reactivity * duration)

            })

        },

        cardSwipeAnimation(vueswing, index, dpi, direction) {

            switch (direction) {
                case 'left':
                    vueswing.$el.parentNode.style.left = `-${index * dpi}px`
                    break
                case 'up':
                    vueswing.$el.parentNode.style.top = `-${index * dpi}px`
                    vueswing.$el.parentNode.style.bottom = `${index * dpi}px`
                    break
                case 'right':
                    vueswing.$el.parentNode.style.left = `${index * dpi}px`
                    break

            }

        },

        btnAction(direction) {

            if (!this.isDisabled) {

                switch (direction) {
                    case 'left':
                        Tag.clickAll(this, 'autodelete')
                        break
                    case 'up':
                        Tag.clickAll(this, 'delete')
                        break
                    case 'right':
                        Tag.clickAll(this, 'keep')
                        break
                }

                this.swing(direction)

            }

        },

        swing(direction) {

            if (this.throwOutConfidence === '0') {

                if (!this.onlyStayInvalidGrant && this.cardArray.length) {

                    const str = 'swing' + (parseInt(this.cardArray.length, 10) - 1)

                    if (this.$refs[str]) {

                        const vueswing = this.$refs[str][0]

                        this.cardSwipeLoopAnimation(vueswing, direction)
                            .then(() => {

                                this.cardsActionUpdate(direction)

                            })
                            .catch(() => {
                            })
                    }

                } else {

                    this.invalidGrant('')
                }
            }

        },

        shareModalClose(shared) {

            this.shared = shared

            if (shared) {

                Storage.setItem('usedSharingCard', true)

            }

        },

        invalidGrant(email) {

            this.$emit('invalidGrant', email)

        }

    },

    destroyed() {

        window.removeEventListener('keydown', this.keydown)
    }
}

</script>

<style lang="scss" scoped>

.page-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 0 16px;
    @media screen and (min-width: $above-tablet-length) {
        display: flex;
        align-items: center;
    }
}

.all-container {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media screen and (min-width: $above-tablet-length) {
        width: 501px;
    }
}

.align-desktop {
    display: flex;
    flex-grow: 1;
}

.swing-relative-container {
    position: relative;
    width: 100%;
    display: flex;
    flex-grow: 1;
    max-height: 400px;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: $above-tablet-length) {
        height: 450px;
        max-height: none;
    }
}

.swing-absolute-container {
    display: flex;
    flex-grow: 1;
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    justify-content: center;
}

.item-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    @media screen and (min-width: $above-tablet-length) {
        width: 501px;
        height: 450px;
    }
}

.btn-container {
    height: 64px;
    width: 100%;
    max-width: 232px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 16px;
    @media screen and (min-width: $above-tablet-length) {
        flex-grow: 1;
        align-items: baseline;
    }
}

.btn-img {
    width: 32px;
    object-fit: contain;
}

.cards {
    display: flex;
    flex-grow: 1;
    position: relative;
}

.card-content {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.decale1 {

}

.decale2 {

}

.mail-container {
    font-size: 11px;
    line-height: 1.45;
    background-color: $aquamarine;
    height: 24px;
    border-radius: 17px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.card-mail {
    font-size: 11px;
    line-height: 1.45;
}

.card-title {
    margin-top: 12px;
    font-size: 20px;
    font-weight: bold;
    line-height: 1.2;
    letter-spacing: -0.2px;
}

.card-subtitle {
    font-size: 12px;
    line-height: 1.33;
}

.card-bottom {
    background-color: $white;
    display: flex;
    flex-grow: 1;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    padding: 16px 24px;
    justify-content: space-between;
}

.background-item-1 {
    background-image: url('/img/background/cards-wood-1.svg');
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: 90%;
}

.background-item-2 {
    background-image: url('/img/background/cards-wood-2.svg');
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: 90%;
}

.card-item-img {
    width: 24px;
    object-fit: contain;
}

.item-text {
    font-size: 11px;
    font-weight: bold;
    line-height: 1.45;
    color: $grey;
}

.bottom-btn-white {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: 100%;
    background-color: $white;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.2);
    cursor: pointer;
}

.bottom-btn-little {
    width: 56px;
    height: 56px;
}

.bottom-btn-img-1 {
    width: 32px;
    object-fit: contain;
}

.bottom-btn-img-2 {
    width: 28px;
    object-fit: contain;
}

.bottom-btn-img-3 {
    width: 36px;
    object-fit: contain;
}

.second-card {
    @media screen and (min-width: $above-tablet-length) {
        top: -8px;
        max-width: 453px;
    }
}

.third-card {
    @media screen and (min-width: $above-tablet-length) {
        top: -16px;
        max-width: 405px;
    }
}

.disabled {
    opacity: 0.5;
}

</style>
